



























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { isAfter } from 'date-fns';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import {ExaminationResult, ItemsBlock, Legend, Result, ResultForm,} from './components';
import Icon from '../../../icon';
import {AppRouterLink} from '@/uikit';

@Component({
  components: {
    Icon,
    Legend,
    Result,
    ItemsBlock,
    ResultForm,
    AppRouterLink,
    ExaminationResult,
  },
})
export default class Block extends Vue {
  @Prop({ type: Object, default: () => {} })
  readonly item!: any;

  @Prop({ type: String, default: '' })
  readonly date!: string;

  @Prop({ type: String, default: '' })
  readonly noFormatDate!: string;

  @Prop({ type: String, default: '' })
  readonly id!: string;

  @Prop({ type: Boolean, default: true })
  readonly showAddition: boolean;

  isOpenBlock = false;
  isShow = false;

  get isDateAfterToday(): boolean {
    return isAfter(this.noFormatDate, new Date());
  }

  get links() {
    const { links } = this.item;
    return isArrayNotEmpty(links) ? links : [];
  }

  get files() {
    const { files } = this.item;
    return isArrayNotEmpty(files) ? files : [];
  }

  get isTest() {
    const { type } = this.item;
    return type === 'tests';
  }

  get isExamination() {
    const { type } = this.item;
    return type === 'examination';
  }

  get isResult() {
    const {
      item: { result },
      isTest,
    } = this;
    return result !== null && isTest;
  }

  get isChecked() {
    const { result } = this.item;
    if (!result || result.status === 'ON_CHECK') return false;
    if (result.status === 'CHECKED') return true;
  }

  get getRouterData() {
    const id = this.item.id;
    const groupId = this.item.group_id;
    const url = this.$router.resolve({
      name: 'profile-examination-item',
      params: { id, groupId },
    });
    return url.href;
  }

  openItemsBlock() {
    this.isOpenBlock = true;
  }

  closeItemBlock() {
    this.isOpenBlock = false;
  }

  openMoreInfo() {
    this.isShow = true;
  }

  closeMoreInfo() {
    this.isShow = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/compopnents/block/Block.vue